﻿define(
//begin v1.x content
({
	loadingState: "Đang tải...",
	errorState: "Rất tiếc, đã xảy ra lỗi"
})
//end v1.x content
);
